import { useParams } from 'react-router-dom';

import {
  isErrorWithMessage,
  openErrorNotification,
  openSuccessNotification,
  getServerErrorText,
} from 'shared/lib';

import { EmptyData, ErrorMessage } from 'shared/ui';

import {
  type CountryDTO,
  type CountryFormData,
  useGetCountryQuery,
  useUpdateCountryMutation,
  CountryForm,
} from 'entities/country';

import { EDIT_ERROR, EDIT_SUCCESS } from '../consts';

const getInitialValues = (country: CountryDTO): CountryFormData => {
  const { isMain, id, ...rest } = country;

  return {
    ...rest,
    id: String(id),
  };
};

export function EditCountry() {
  const [trigger, { isLoading: isMutationLoading }] =
    useUpdateCountryMutation();

  const { countryId } = useParams() as { countryId: string };

  const { isFetching, error, data } = useGetCountryQuery(countryId);

  const handleSubmit = async (values: CountryFormData) => {
    try {
      const res = await trigger(values).unwrap();

      // костыль
      if (res.statusCode !== 0) {
        openErrorNotification(res.statusDescription);
        return;
      }
      //

      openSuccessNotification(EDIT_SUCCESS);
    } catch (err) {
      const hasErrorMessage = isErrorWithMessage(err);

      const errorText = hasErrorMessage
        ? err.data.statusDescription
        : EDIT_ERROR;

      openErrorNotification(errorText);
    }
  };

  if (isFetching) {
    return <div>Loading...</div>;
  }

  if (data && data.statusCode !== 0) {
    return <ErrorMessage text={data.statusDescription} />;
  }

  if (error) {
    return <ErrorMessage text={getServerErrorText(error)} />;
  }

  if (!data?.country) {
    return <EmptyData />;
  }

  const initialValues = getInitialValues(data.country);

  return (
    <CountryForm
      handleSubmit={handleSubmit}
      loading={isMutationLoading}
      title={data.country.name}
      initialValues={initialValues}
      disabled
    />
  );
}
